export const SSO_AUTH_URL =
  window?.__ENV__?.REACT_APP_SSO_AUTH_URL ??
  process?.env?.REACT_APP_SSO_AUTH_URL

export const SSO_CLIENT_ID =
  window?.__ENV__?.REACT_APP_SSO_CLIENT_ID ??
  process?.env?.REACT_APP_SSO_CLIENT_ID
